import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AutenticacaoService } from 'src/app/services/autenticacao.service';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { UtilService } from 'src/app/services/util.service';
import { PreAdesaoService } from 'src/app/services/pre-adesao.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-reenviar-token-email',
    templateUrl: './reenviar-token-email.component.html',
    styleUrls: ['./reenviar-token-email.component.css'],
    imports: [ReactiveFormsModule, FormsModule, CommonModule]
})
export class ReenviarTokenEmailComponent implements OnInit {
  [x: string]: any;

  public form: FormGroup = null;
  public loading: boolean = false;

  public msgErro: string = null;
  public concluido: boolean = false;
  token : string;
  cpf :string;


  constructor(public autenticacao: AutenticacaoService, private util: UtilService,private preAdesaoService: PreAdesaoService,
    private http: HttpClient,private router: Router) {

    this.form = new FormGroup({
      cpf: new FormControl(null, [Validators.required]),
      email: new FormControl(null, [Validators.required, Validators.email]),
      token: new FormControl(null)
    });
  }

  ngOnInit() {

  }

  reenviar(){

    let cpf = this.form.get('cpf').value;
    let email = this.form.get('email').value;

    this.loading = true;
    this.form.disable();

    this.autenticacao
    .reenviarTokenEmail(cpf, email)
    .pipe(
      finalize(() => {
                      this.loading = false;
                      this.form.enable();
                    })
    )
    .subscribe(
      (res: any) => {
        this.msgErro = null;
        this.concluido = true;

      },
      (httpError: HttpErrorResponse) => {

        if(httpError.status==400){
          this.msgErro = httpError.error.ex;

          setTimeout(()=> {
            this.msgErro = null;
          }, 6000);
        }

      }
    );
  }

 validarToken() {

     this.loading = true;

      const cpf = this.cpf.replace(/[.-]/g, "");

    this.http
     .post(`${environment.apiURL}/Aberto/ConfirmarEmail/ValidarToken`, {token: this.token, cpf: cpf})
     .pipe(
       finalize(()=> {this.loading = false})
     )
     .subscribe(
       (status: boolean) => {

         if(status){
          alert("Validação Confirmada !");
          this.router.navigate(['/autenticacao/login']);

         }else{
           alert("Código de verificação inválido");
         }

       },
       httpError => {
         console.error(httpError);
         this.msgErro = httpError.error.ex;
       }
     );

   }


}
